import React from "react";
import foundPage from "../../assets/images/not_foundPage.svg";

const NotFound = ({ history }) => {
    return (
        <div className="not_found_Page" >
            <div className="not_found_wrapper">
                <div className="not_found_content">
                    <div className="notfound mb_40"><img src={foundPage} alt="notfound" /></div>
                    <h3>Oops! That page can’t be found.</h3>
                    <p>It looks like nothing was found at this location, please go to back the <a className="text_primary_blue" onClick={() => history.push('/')}>homepage</a></p>
                </div>
            </div>
        </div>
    )
};

export default NotFound